import { CycleUtils } from '@wix/package-picker-shared';
import { PurchaseOffering } from '@wix/premium-purchase-platform/@sdk';
import { useCurrentModule } from '../components/ModuleProvider';
export const useCycleName = _ref => {
  var _cycle$cycleDuration, _cycle$cycleDuration2;
  let {
    cycle,
    showInMonths,
    lowerCase
  } = _ref;
  const module = useCurrentModule();
  const {
    t
  } = module.internals.useTranslations();
  if (!cycle) {
    return;
  }
  if (showInMonths || ((_cycle$cycleDuration = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration.unit) === PurchaseOffering.DurationUnit.MONTH) {
    const cycleName = t('premium-purchase-plan.cycle_selector.cycle_months', {
      count: CycleUtils.convertCycleDurationToMonths(cycle)
    });
    return lowerCase ? cycleName.toLowerCase() : cycleName;
  }
  const cycleName = t('premium-purchase-plan.cycle_selector.cycle_years', {
    count: (_cycle$cycleDuration2 = cycle.cycleDuration) == null ? void 0 : _cycle$cycleDuration2.count
  });
  return lowerCase ? cycleName.toLowerCase() : cycleName;
};
//# sourceMappingURL=useCycleName.js.map